/**
 * Shim for @clariness/checkbox: re-exports with optional pointer/crossOrigin props
 * so React 19 types don't require them (theme-ui Pick<> types treat them as required).
 */
import React from 'react';
import {
  Checkbox as OrigCheckbox,
  type CheckboxProps,
} from '~clariness-checkbox';

type OptionalProps = {
  placeholder?: string;
  onPointerEnterCapture?: React.PointerEventHandler;
  onPointerLeaveCapture?: React.PointerEventHandler;
  crossOrigin?: string;
};

export type { CheckboxProps };
export const Checkbox = OrigCheckbox as React.ForwardRefExoticComponent<
  Omit<React.ComponentProps<typeof OrigCheckbox>, keyof OptionalProps> &
    OptionalProps &
    React.RefAttributes<HTMLInputElement>
>;
